<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import FooterBlock from "@/components/FooterBlock.vue";

export default {
  name: "App",
  components: {
    FooterBlock,
  },
};
</script>

<style></style>
